// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"wq_a bhu_b","TwoDimsListFeature__item":"wq_b bhu_ux","TwoDimsListFeature__item__text":"wq_c bhu_un"};